<template>
  <el-dropdown @command="handleCommand" @visible-change="handleVisibleChange">
    <span class="avatar-dropdown">
      <el-avatar class="user-avatar" :src="avatar" />
      <div class="user-name">
        <span v-if="currentTeamIfo?.title">{{ currentTeamIfo.title }}-</span>
        <div>{{ username }}</div>
        <vab-icon
          class="vab-dropdown"
          :class="{ 'vab-dropdown-active': active }"
          icon="arrow-down-s-line"
        />
      </div>
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="personalCenter">
          <vab-icon icon="user-line" />
          <span>{{ translateTitle('个人中心') }}</span>
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          <vab-icon icon="logout-circle-r-line" />
          <span>{{ translateTitle('退出登录') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
  import {
    computed,
    defineComponent,
    reactive,
    ref,
    toRefs,
    getCurrentInstance,
    onBeforeMount,
  } from 'vue'
  import { useStore } from 'vuex'
  // import { useRoute, useRouter } from 'vue-router'
  import { useRouter } from 'vue-router'
  import { toLoginRoute } from '@/utils/routes'
  import { translateTitle } from '@/utils/i18n'
  import { clearStorage, clearSessionStorage } from '@/utils/token'
  import { fillUrl } from 'common/js/utils'
  import { switchTeam } from '@/api/user'
  export default defineComponent({
    name: 'VabAvatar',
    setup() {
      const store = useStore()
      // const route = useRoute()
      const router = useRouter()
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogVisible: false,
      })
      const teamList = computed(() => store.getters['user/currentAppTeamList'])
      const currentTeamId = computed(() => store.getters['user/currentTeamId'])
      const currentTeamIfo = computed(() => {
        let result = null
        if (currentTeamId.value) {
          result = teamList.value.find(
            (item) => item.id === currentTeamId.value
          )
        }
        return result
      })
      const logout = () => store.dispatch('user/logout')
      const active = ref(false)

      const handleVisibleChange = (val) => {
        active.value = val
      }
      const handleCommand = async (command) => {
        switch (command) {
          case 'logout':
            await logout()
            clearStorage()
            clearSessionStorage()
            await router.push(toLoginRoute())
            // await router.push(toLoginRoute(route.fullPath))
            break
          case 'personalCenter':
            await router.push('/setting/personalCenter')
            break
          case 'swichRole':
            state.dialogVisible = true
            break
          case 'myBillList':
            await router.push('/finance/billList')
            break
        }
      }

      // 切换团队
      const handleChangeTeam = async (val) => {
        switchTeam({ team_id: val })
          .then(async () => {
            await store.dispatch('routes/changeProductTeam')
            state.dialogVisible = false
            proxy.$pub('reload-router-view')
          })
          .catch(() => {
            console.log('window.location.reload   >>>>>>>>>')
            // window.location.reload()
          })
      }

      const delAllVisitedRoutes = (activePath) =>
        store.dispatch('tabs/delAllVisitedRoutes', activePath)

      onBeforeMount(() => {})
      return {
        ...toRefs(state),
        currentTeamId,
        active,
        teamList,
        fillUrl,
        currentTeamIfo,
        handleCommand,
        translateTitle,
        handleVisibleChange,
        handleChangeTeam,
        delAllVisitedRoutes,
        avatar: computed(() => store.getters['user/avatar']),
        username: computed(() => store.getters['user/username']),
      }
    },
  })
</script>

<style lang="scss" scoped>
  .avatar-dropdown {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;

    .user-avatar {
      width: 40px;
      height: 40px;
      margin-left: 15px;
      cursor: pointer;
      border-radius: 50%;
    }

    .user-name {
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      height: 40px;
      margin-left: 6px;
      line-height: 40px;
      cursor: pointer;

      [class*='ri-'] {
        margin-left: 0 !important;
      }
    }
  }

  :deep() {
    .el-radio {
      &__label {
        display: none;
      }
    }
  }
  ul.list-container {
    padding: 0;
    margin: 0;
    list-style: none;
    outline: none;
    .list-item {
      padding: $base-padding;
      font-size: 14px;

      &-meta {
        display: flex;
        flex: 1 1;
        align-items: flex-start;

        &-avatar {
          margin-right: 16px;

          :deep() {
            .el-image {
              width: 61px;
              height: 61px;
            }
          }
        }

        &-item {
          display: inline-block;
          height: 61px;
          margin-left: 40px;
          color: rgba(0, 0, 0, 0.45);
          vertical-align: middle;

          > span {
            line-height: 30px;
          }

          > p {
            margin-top: 4px;
            margin-bottom: 0;
          }
        }

        :deep() {
          .el-progress {
            margin-top: 21px;
          }
        }
      }
    }
  }
</style>
